<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HouseSelect',
})
</script>
<template>
  <Select
    v-model:value="selectedValues"
    mode="multiple"
    :options="options"
    :loading="loading"
    placeholder="请选择房屋"
    allow-clear
    style="width: 100%"
  />
</template>

<script lang="ts" setup name="HouseSelect">
import { computed, ref, watch } from 'vue'
import { Select } from 'ant-design-vue'
import { API_JT_ZCH_HOUSE_LIST } from '@/api/jtZch'

const props = defineProps<{
  /** 征拆户ID */
  id: string
  /** 选中的房屋ID数组 (v-model) */
  value?: string[]
}>()

const emit = defineEmits<{
  (e: 'update:value', val: string[]): void
}>()

const loading = ref(false)
const houseList = ref<ApiJtZch.HouseItem[]>([])

const options = computed(() =>
  houseList.value.map(item => ({
    label: `${item.buildingName} ${item.buildingNumber}`,
    value: item.houseId
  }))
)

const selectedValues = computed({
  get: () => props.value ?? [],
  set: (val: string[]) => emit('update:value', val)
})

const fetchHouseList = async (id: string) => {
  loading.value = true
  try {
    houseList.value = await API_JT_ZCH_HOUSE_LIST(id)
  } finally {
    loading.value = false
  }
}

watch(
  () => props.id,
  id => {
    if (id) {
      fetchHouseList(id)
    } else {
      houseList.value = []
    }
    // id 变化时清空已选
    emit('update:value', [])
  },
  { immediate: true }
)
</script>
